import IntraserTabLogo from 'assets/icons/tenant/intraser-tab-logo.svg';
import OntruckTabLogo from 'assets/icons/ontruck-tab-logo.svg';
import XPOTabLogo from 'assets/icons/xpo/xpo-tab-logo.svg';
import RPTTabLogo from 'assets/icons/rpt/rpt-tab-icon.png';
import OnTimeIcon from 'assets/icons/ontime/ontime-icon.png';
import AlianzaLogo from 'assets/icons/alianza/alianza-logo.svg';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import { TENANTS_NAMES } from 'tenant/host_config';

export const TabIcon = () => {
  const iconConfig = getTenantPreLoginConfig().tab_icon;
  const Icons = {
    [TENANTS_NAMES.ontruck]: OntruckTabLogo,
    [TENANTS_NAMES.intraser]: IntraserTabLogo,
    [TENANTS_NAMES.xpo]: XPOTabLogo,
    [TENANTS_NAMES.rpt]: RPTTabLogo,
    [TENANTS_NAMES.ontime]: OnTimeIcon,
    [TENANTS_NAMES.alianza]: AlianzaLogo,
  };
  return Icons[iconConfig];
};
